import React from 'react';

type HangmanProps = {
  errors: number;
};

const HangmanStickmanSVG: React.FC<HangmanProps> = ({ errors }) => {
  const strokeColor = errors > 8 ? 'red' : 'black';

  const strokeStyle = {
    stroke: strokeColor,
    strokeWidth: 3,
    strokeLinecap: 'round' as const,
    strokeLinejoin: 'round' as const,
    fill: 'none',
  };

  const drawEffect = {
    strokeDasharray: 1000,
    strokeDashoffset: 1000,
    animation: 'draw 5s ease-out forwards',
  };

  return (
    <>
      <style>
        {`
          @keyframes draw {
            to {
              stroke-dashoffset: 0;
            }
          }
        `}
      </style>

      <svg width="200" height="200" viewBox="0 0 200 250">
        {/* Líneas base siempre visibles */}
        <line x1="0" y1="230" x2="250" y2="230" style={{ ...strokeStyle, ...drawEffect }} />
        <line x1="20" y1="230" x2="20" y2="2" style={{ ...strokeStyle, ...drawEffect }} />
        

        {/* Nueva línea diagonal escuadra */}
        {errors > 0 && <line x1="80" y1="2" x2="20" y2="60" style={{ ...strokeStyle, ...drawEffect }} />}
        {errors > 1 &&<line x1="20" y1="2" x2="175" y2="2" style={{ ...strokeStyle, ...drawEffect }} />}

        {/* Estructura horizontal y muñeco según errores */}        
        {errors > 2 && <line x1="140" y1="2" x2="140" y2="40" style={{ ...strokeStyle, ...drawEffect }} />}
        {errors > 3 && <circle cx="140" cy="60" r="20" style={{ ...strokeStyle, ...drawEffect }} />}
        {errors > 4 && <line x1="140" y1="80" x2="140" y2="150" style={{ ...strokeStyle, ...drawEffect }} />}
        {errors > 5 && <line x1="140" y1="95" x2="110" y2="125" style={{ ...strokeStyle, ...drawEffect }} />}
        {errors > 6 && <line x1="140" y1="95" x2="170" y2="125" style={{ ...strokeStyle, ...drawEffect }} />}
        {errors > 7 && <line x1="140" y1="150" x2="110" y2="185" style={{ ...strokeStyle, ...drawEffect }} />}
        {errors > 8 && <line x1="140" y1="150" x2="170" y2="185" style={{ ...strokeStyle, ...drawEffect }} />}
      </svg>
    </>
  );
};

export default HangmanStickmanSVG;
